<template>
    <div class="wrap">
        <div class="content" :style="{height: height}">
            <base-header :name="user_name" :topOnly="flag_top" :account_list="account_list"></base-header>
            <ul class="tab-ul">
                <li :class="`tab-li tab-li-${item} ${tab==item?'choosed':''}`" v-for="item in 4" :key="item" @click="change_tab(item)"></li>
            </ul>
            <div class="part part-1" v-if="tab==1">
                <div class="part-content">
                    <!-- 每日任务 -->
                    <div class="task-list">
                        <div :class="`task-item task-item${index}`" v-for="(item, index) in day_list" :key="index">
                            <div class="name" v-if="index==3">
                                每
                                <span @click="openBuyPop()">开通/续费</span>1个月PLUS
                            </div>
                            <div class="name" v-else>{{item.packet_name}}</div>

                            <div class="reward">
                                奖励：
                                <span>{{item.items_name.join(' ')}}</span>
                                <span v-if="index===1">（最多领6个）</span>
                                <span v-else-if="index===3">（最多仅获得120个）</span>
                            </div>
                            <div :class="'btn btn1 '+(is_signed==1?'over':is_signed==0?'get':'')" @click="to_sign()" v-if="index==0"></div>
                            <div :class="'btn btn2 '+ item.status" v-else-if="index==2" @click="open_packet_plus(item, index)"></div>
                            <div class="other" v-if="index==1||index==3">
                                已自动获得：
                                <span>{{(item.packet?item.packet.add_count:0) * item.items[0].count}}个</span>
                            </div>
                            <div class="other other2" v-if="index==2">
                                可领取：
                                <span>{{(item.packet?item.packet.balance:0) * item.items[0].count}}个</span>
                                <br />已领取：
                                <span>{{(item.packet?item.packet.sub_count:0) * item.items[0].count}}个</span>
                            </div>
                            <div class="plus" v-if="index>1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part part-2" v-else-if="tab==2">
                <div class="tip">
                    每跑完一圈，
                    <span>额外赠送588个气球；</span>且跑圈的气球全部翻*1倍，最高6倍奖励！
                </div>
                <div class="mm" v-if="multiple>1">
                    当前气球加成：
                    <span>{{multiple}}倍</span>
                </div>
                <div class="mm" v-else></div>
                <div class="board">
                    <div :class="'cell cell-'+ index" v-for="(item, index) in goodsList" :key="index">
                        <div :class="`multiple m-${multiple}`" v-if="multiple>1 && index%6!==0"></div>
                        <div :class="'current current-'+ index" v-if="index == i"></div>
                        <img :src="require(`@/assets/img/nationalDay/gift/${index%6}.png`)" alt srcset />
                        <div class="chess-box" v-if="index == i">
                            <div class="chess"></div>
                            <div class="chess-shadow"></div>
                        </div>
                    </div>
                    <div class="info">
                        <p>
                            每点数为
                            <span>6</span>，超幸运！可获得对应奖励并停留
                        </p>
                        <p>
                            <em>其他点数时，可获得对应奖励，并返回上一停留点</em>
                        </p>
                    </div>
                    <div class="dice">
                        <img id="dice" class="dice-img" :src="require(`@/assets/img/nationalDay/card/${dice_url}`)" alt />
                    </div>
                    <div class="amount">
                        剩余机会:
                        <span>{{chance_amount}}</span> &nbsp;&nbsp;&nbsp;拥有气球:
                        <span>{{ball_amount}}</span>
                    </div>
                    <div :class="`btn ${chance_amount>0?'get':''}`" @click="rollDice()"></div>
                </div>
                <!-- 排行榜 -->
                <div class="rank">
                    <div class="title title2"></div>
                    <div class="my-rank">
                        我的排名：
                        <span>{{my_rank.rank}}</span>
                        圈数：
                        <span>{{my_rank.circle_count}}</span>
                        我的总点数：
                        <span>{{my_rank.step}}</span>
                        <div class="question">
                            <div class="tips">
                                <p>1、跑圈排行榜奖励≥1圈才能上榜；排名规则跟：圈数/总点数/更新时间有关</p>
                                <p>2、排行榜奖励每日0点自动发放至账号上</p>
                                <p>&nbsp;&nbsp;前3名：4000酒豆（有效期7天）</p>
                                <p>&nbsp;&nbsp;4-10名：3000酒豆（有效期7天）</p>
                                <p>&nbsp;&nbsp;11-30名：2000酒豆（有效期7天）</p>
                                <p>&nbsp;&nbsp;31-100名：1000酒豆（有效期7天）</p>
                                <p>排行榜名次每10分钟更新</p>
                            </div>
                        </div>
                    </div>
                    <div class="rank-box">
                        <div class="tt each">
                            <span>排名</span>
                            <span>玩家名称</span>
                            <span>圈数</span>
                            <span>总点数</span>
                            <div class="line"></div>
                        </div>
                        <div class="each" v-for="(item, index) in rank_list" :key="index">
                            <span>{{item.rank}}</span>
                            <span>{{item.name}}</span>
                            <span>{{item.circle_count}}</span>
                            <span>{{item.step}}</span>
                            <div class="line"></div>
                        </div>
                        <div class="bottom">
                            <div class="left" @click="changePage(pageIndex-1)"></div>
                            <div class="num">
                                <span>{{pageIndex}}</span>
                                /{{total}}
                            </div>
                            <div class="right" @click="changePage(pageIndex+1)"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="part part-3" v-else-if="tab==3">
                <p class="part-tip">
                    拥有气球：
                    <span>{{ball_amount}}</span>&nbsp;个
                </p>
                <div class="part-content">
                    <div class="exchange-list">
                        <div :class="`exchange-item exchange${d}`" v-for="(i,d) in exchange_list" :key="d">
                            <div class="exchange-name">
                                <p>{{i.packet_name}}</p>
                            </div>
                            <div :class="'exchange-img exchange'+d">
                                <img :src="'https://cdn.09game.com/resources/item/dj_'+i.items[0].id+'_200.png'" :title="i.packet_name" alt />
                            </div>
                            <div class="other">
                                <p class="exchange-reward">
                                    消耗：
                                    <span>{{'气球*'+i.count}}</span>
                                </p>
                            </div>
                            <div :class="'btn '+(i.have?'over':i.count <= ball_amount ?'get':'')" @click="exchange(i, d)"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="part part-4" v-else-if="tab==4">
                <div class="title title3"></div>
                <div class="info">仅展示近50条记录</div>

                <div class="logs">
                    <div class="log-li tt">
                        <div class="name">兑换时间</div>
                        <div class="time">物品</div>
                        <div class="ex">来源</div>
                    </div>
                    <ul class="log-ul" v-if="log_list.length>0">
                        <li class="log-li" v-for="(item, index) in log_list" :key="index">
                            <div class="name">{{item.create_time.substring(5)}}</div>
                            <div class="time">{{item.getMsg}}</div>
                            <div :class="`ex ${item.type==1?'ex2':item.item_id>=918408 && item.item_id<=918412 ? 'ex3':'ex1'}`">
                                {{item.type==1?'玩转好礼':(item.item_id>=918404 && item.item_id<=918407?'排行榜奖励':item.item_id>=918408 && item.item_id<=918412 ? '奖励兑换':
                                item.item_id==918402 || item.item_id==918403 || item.packet_id == 918413 ? '福利任务': item.item_id==918401 ? '每日签到':'') }}
                            </div>
                        </li>
                    </ul>
                    <div class="nodata" v-else>暂无记录~</div>
                </div>
            </div>

            <div class="part explain" :style="{'margin-top': tab==2?'.36rem':'.47rem'}">
                <div class="title title1"></div>
                <div class="ex-box">
                    <p>1、您需要关注《09电竞》公众号、并绑定平台账号后才能参加活动。</p>
                    <p>2、平台等级≥10或贵宾等级≥1才可进行签到，每天00:00之后可以进行当日签到</p>
                    <p>3、获得的平台道具奖励将直接发放在账号上，登录平台pc客户端可查看奖励</p>
                    <p>4、本活动结束后会清空所有“转转机会”及“气球”</p>
                    <p>5、本活动所有符文石及酒豆有效期7天</p>
                    <p>6、最终解释权归《09电竞》所有</p>
                </div>
            </div>
            <div class="mate-info"></div>

            <div class="mark" v-if="pop_show"></div>
        </div>
        <div :class="`pop ${pop_show=='buyPlus'?'pop1':''}`" v-if="pop_show">
            <div class="tite" v-if="pop_show!=='toast'">{{ pop_show=='toast'?'中奖提示':pop_show=='buyPlus'?'购买09平台-PLUS':'请选择兑换的奖励'}}</div>
            <div class="close" v-if="pop_show!=='toast'" @click="close_pop()"></div>
            <div class="inner">
                <!-- 恭喜获得 -->
                <div v-if="pop_show=='toast'" class="toast" @click="close_pop()">
                    <p class="p1">
                        <span>-恭喜获得-</span>
                    </p>
                    <p class="p2">{{prize?prize:'-'}}</p>
                    <div class="btns">
                        <ul>
                            <li class="sure" @click="close_pop()"></li>
                        </ul>
                    </div>
                </div>
                <!-- 购买plus礼包 -->
                <div v-else-if="pop_show=='buyPlus'" class="buyPlus">
                    <div class="tip">
                        选择购买plus时长
                        <div class="rr">
                            我的酒币剩余：
                            <span>{{jiubi}}</span>
                        </div>
                    </div>
                    <ul class="buy-ul">
                        <li :class="`buy-li ${buy_index===index?'choosed':''}`" v-for="(item, index) in buyList" :key="index" @click="buy_index = index">
                            <div class="times">{{item.times}}天</div>
                            <div class="price">{{item.money}}酒币</div>
                            <div :class="`discount discount${item.discount}`" v-if="item.discount!=10"></div>
                            <div class="other" v-if="item.dis">{{item.dis}}</div>
                            <div class="tick" v-if="buy_index === index"></div>
                            <div class="info" v-if="index===2">为了平台玩家体验，零玖电竞有权对Plus表现形式、奖励、特权进行调整（平台官网公告），购买代表同意</div>
                        </li>
                    </ul>
                    <div class="detail">
                        <em>将消耗：</em>
                        <span>{{buyList[buy_index].money}}酒币</span>开通
                        <span>{{buyList[buy_index].times}}天平台Plus</span>
                    </div>
                    <div class="btns">
                        <ul>
                            <li class="btn" @click="buy_goods()"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { isToday, setEndTime } from '@/utils/common'
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
const shop_url = baseUrls.shop_url
const hd_url = 'https://hd.09game.com/guoqing/'
// const hd_url = 'http://127.0.0.1:5070/' //注释

export default {
    name: 'nationalDay',
    data() {
        return {
            app_id: 91840,
            height: '100vh',
            flag_top: true,
            tab: 1,
            token: this.$storage.getToken(),
            user_id: '',
            user_name: '',
            account_list: [],
            pop_show: '', //打开弹框的类型
            btn_lock: false, //防抖
            is_signed: -1, //是否签到 1已签到 0未签到 -1初始
            videoUrl: '', //预览地址
            videoName: '', //预览名称
            exchange_list: [],
            day_list: [],
            goodsList: [],
            i: 0, //转到哪个位置
            count: 0, //转圈初始值
            totalCount: 0, //转动的总圈数
            speed: 300, //转圈速度，越大越慢
            minSpeed: 200,
            timer: null,
            current_index: 0, //指定转到哪个奖品,
            prize: '', //中奖信息
            oPlay: true,
            timer_dice: false,
            dice_url: '0.png',
            step_now: 0,
            chance_id: 20151, //转盘机会id
            chance_amount: 0,
            ball_id: 20152, //气球道具id
            ball_amount: 0,
            my_used_packet: [],
            log_list: [], //获奖记录
            user_info: {},
            buyList: [
                { money: 490, times: 30, dis: '', id: 900801, discount: 10 },
                { money: 2590, times: 180, dis: '立省35元', id: 900803, discount: 9 },
                { money: 4990, times: 360, dis: '立省89元', id: 900804, discount: 8 },
            ],
            jiubi: 0, //我的酒币
            buy_index: 0,
            pay_jiubi: 0,
            pageIndex: 1,
            pageSize: 10,
            total: 0,
            rank_list: [],
            my_rank: { circle_count: 0, rank: '-', step: 0 },
            total_step: 0,
            multiple: 1, //倍数
            screenHeight: 0,
            screenWidth: 0,
            timer_rank: null,
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (vm.$common.checkToken(vm.token)) {
                vm.$http.set_anchor(12, vm.token)
            }
        })
    },

    created() {
        // setEndTime('2024-10-7 23:59:59');
        this.handleResize()
        this.requireToken()
        this.startTimer()
    },
    beforeDestroy() {
        if (this.timer_rank) {
            clearInterval(this.timer_rank)
        }
    },
    watch: {
        tab(newVal, oldVal) {
            // console.log(newVal);
            let hh = newVal == 1 ? '13.34' : newVal == 2 ? '23.98' : newVal == 3 ? '15.5' : '18.32'
            let sh = (this.screenHeight * 2) / 100
            this.height = (sh > hh ? sh : hh) + 'rem'
        },
    },
    methods: {
        // 设置定时器函数
        startTimer() {
            // console.log('计时器开始！')
            // 60秒后执行
            this.timer_rank = setInterval(() => {
                if (this.tab == 2) {
                    this.getMyRank()
                    this.getRank()
                }
            }, 600000)
        },
        handleResize() {
            // 根据窗口修改元素的大小
            this.screenHeight = window.innerHeight
            this.screenWidth = window.innerWidth
            // console.log(this.screenWidth+'-'+this.screenHeight);
        },
        // 查询是否已签到
        query_sign_info() {
            this.$http.q_hd('GetTurntableLog', hd_url, { token: this.token, type: 2 }).then((res) => {
                if (res.code == 0 && res.msg) {
                    this.is_signed = isToday(res.msg.create_time) ? 1 : 0
                } else {
                    this.is_signed = 0
                }
            })
        },
        // 查询我的排行数据
        getMyRank() {
            let _this = this
            this.$http.q_hd('GetTurnUser', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0) {
                    if (res.info) {
                        this.my_rank = res.info
                    } else {
                        this.my_rank = { circle_count: 0, rank: '-', step: 0 }
                    }
                }
            })
        },
        // 查询排行榜
        getRank() {
            let _this = this
            this.rank_list = []
            this.$http
                .q_hd('GetTurnRank', hd_url, { token: this.token, PageSize: this.pageSize, PageIndex: this.pageIndex })
                .then((res) => {
                    if (res.code == 0) {
                        if (res.temp && res.temp.items) {
                            this.rank_list = res.temp.items
                            this.total =
                                Math.ceil(res.temp.pagecount / this.pageSize) > 10 ? 10 : Math.ceil(res.temp.pagecount / this.pageSize)
                        } else {
                            this.rank_list = []
                            this.total = 0
                        }
                    }
                })
        },
        // 查询转盘获取道具记录
        query_turn_log() {
            let _this = this
            this.log_list = []
            this.$http.q_hd('GetTurntableLog', hd_url, { token: this.token, type: 1 }).then((res) => {
                if (res.code == 0 && res.msg) {
                    for (let i in res.msg) {
                        let data = res.msg[i]
                        if (data.type == 2 && data.result) {
                            let result = parseInt(data.result.split(':')[0]) + 1
                            data.getId = JSON.parse(data['gift' + result + '_setting']).id
                            data.getMsg = JSON.parse(data['gift' + result + '_setting']).name
                        } else {
                            data.getId = data.item_id
                            data.getMsg = data.item_name
                        }
                        _this.log_list.push(data)
                    }
                }
            })
        },
        // 获取转盘信息
        getTurnTable() {
            this.$http.q_hd('GetTurntable', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg && res.msg.length > 0) {
                    this.goodsList = res.msg.concat(res.msg).concat(res.msg).concat(res.msg)
                }
                this.current_index = parseInt(res.step) % 24
                this.multiple = res.multiple
                this.i = this.current_index
            })
        },
        // 获取转盘信息
        getBeishu() {
            this.$http.q_hd('GetTurntable', hd_url, { token: this.token }).then((res) => {
                this.multiple = res.multiple
            })
        },
        changePage(val) {
            if (val < 1) {
                return false
            }
            if (val > this.total) {
                return false
            }
            this.pageIndex = val
            this.getRank()
        },
        openBuyPop(){
            if(this.day_list[3].packet && this.day_list[3].packet.add_count >= 60){
                 this.mate_show('.task-item3 .name span', '当前购买已达参与上限！', -40)
                 return false
            }
            this.pop_show = 'buyPlus'
        },
        // 查询活动相关接口
        async query_app() {
            var _this = this
            this.day_list = []
            this.exchange_list = []

            // 查询活动礼包
            await this.$http.q_cfg_packet(this.app_id).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        item.status = ''
                        item.items = []
                        item.items_name = []
                        item.name = ''
                        for (var i = 1; i <= 6; i++) {
                            var obj = item['gift' + i + '_setting']
                            if (obj) {
                                item.items.push(JSON.parse(obj))
                                item.items_name.push(JSON.parse(obj).name)
                            }
                        }

                        if ((item.packet_id >= 918401 && item.packet_id <= 918403) || item.packet_id == 918413) {
                            _this.day_list.push(item)
                        }
                        if (item.packet_id >= 918408 && item.packet_id <= 918412) {
                            _this.exchange_list.push(item)
                        }
                    }
                }
            })

            await this.$http.q_cfg_item(this.ball_id).then((res) => {
                if (res.code == 0) {
                    let obj = res.records[0]
                    let arr = obj.setting ? JSON.parse(obj.setting).ex : []
                    for (let i in this.exchange_list) {
                        let item = this.exchange_list[i]
                        item.count = 0
                        item.status = ''
                        for (let each of arr) {
                            if (item.packet_id == each.packet) {
                                item.count = each.count
                            }
                        }
                        this.$set(this.exchange_list, i, item)
                    }
                }
            })

            await this.query_my_packet()
            await this.query_sign_info()

            this.chance_amount = this.query_my_item(this.chance_id)
            this.ball_amount = this.query_my_item(this.ball_id)
        },

        // 查询我的礼包
        query_my_packet() {
            var _this = this
            this.$http.q_my_packet(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (let day of _this.day_list) {
                            if (day.packet_id == item.packet_id) {
                                day.packet = item
                            }
                        }
                    }
                }
                this.initPage()
            })
        },

        // 查询礼包使用情况
        async query_use_packet() {
            let _this = this
            _this.my_used_packet = []

            await this.$http.q_my_packet_use(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    let arr = []
                    for (let item of res.records) {
                        arr.push(item)
                    }

                    for (let a of arr) {
                        let result = parseInt(a.result.split(':')[0]) + 1
                        a.getId = JSON.parse(a['gift' + result + '_setting']).id
                        a.getMsg = JSON.parse(a['gift' + result + '_setting']).name
                        _this.my_used_packet.unshift(a)
                    }
                }
            })
        },

        // 查询我的道具数量
        query_my_item(id) {
            var _this = this
            var amount = 0
            $.ajax({
                url: shop_url + JSON.stringify({ type: 'q_my_item', json: JSON.stringify({ item_id: id, token: this.token }) }),
                async: false,
                success: (res) => {
                    if (res.code == 0) {
                        amount = res.records[0].amount
                    }
                },
            })
            return amount
        },
        // 签到
        to_sign() {
            let text = ''
            let element = '.part-1 .task-item0 .btn'
            if (this.btn_lock) {
                return false
            }
            if (this.is_signed == 1) {
                return false
            }
            this.btn_lock = true
            this.$http.q_hd('TurntableSkin', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0) {
                    text = '签到成功！'
                    this.$http.use_packet(this.day_list[0].packet_id, this.token).then((rr) => {
                        if (rr.code == 0) {
                        }
                        this.is_signed = 1
                        this.btn_lock = false
                        this.mate_show(element, text, -40)
                        this.chance_amount = this.query_my_item(this.chance_id)
                    })
                } else {
                    text = res.msg ? res.msg : '签到失败！'
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                }
            })
        },
        // 兑换
        exchange(item, index) {
            let text = ''
            let element = `.exchange-list .exchange${index} .btn`
            if (this.btn_lock) {
                return false
            }
            if (item.count > this.ball_amount) {
                return false
            }
            this.btn_lock = true
            this.$http.use_item(this.ball_id, this.token, item.count).then((res) => {
                if (res.code == 0) {
                    text = '兑换成功！'
                    this.ball_amount = this.query_my_item(this.ball_id)
                    this.initPage()
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                } else {
                    text = res.info ? res.info : '兑换失败！'
                    this.btn_lock = false
                    this.mate_show(element, text, -40)
                }
            })
        },
        // 重置按钮状态
        initPage() {
            // 每日任务
            for (let day of this.day_list) {
                if (day.packet_id == 918402 || day.packet_id == 918403 || day.packet_id == 918413) {
                    let packet = day.packet
                    if (packet) {
                        if (packet.balance > 0 && packet.expire_days > 0) {
                            day.status = 'get'
                        } else if (packet.balance == 0 && packet.expire_days > 0) {
                            day.status = 'over'
                        } else {
                            day.status = ''
                        }
                    } else {
                        day.status = ''
                    }
                }
            }

            this.$forceUpdate()
        },
        buy_goods() {
            let _this = this
            if (_this.btn_lock) {
                return
            }
            let element = `.pop .buyPlus .btns`

            if (this.buy_index == -1) {
                this.mate_show(element, '请选择购买时长！', -30)
                return false
            }
            let item = this.buyList[this.buy_index]
            _this.btn_lock = true
            this.$http.buy_goods(item.money, item.id, this.token).then((res) => {
                if (res.code == 0) {
                    this.btn_lock = false
                    this.getBaseInfo()
                    this.query_my_packet()
                    this.chance_amount = this.query_my_item(this.chance_id)
                    this.mate_show(element, '开通/续费PLUS成功！', -20)
                    this.close_pop()
                } else {
                    if (res.code == 14) {
                        this.pay_jiubi = item.money
                        this.btn_lock = false
                        this.buy()
                    } else {
                        this.mate_show(element, res.info, -20)
                        _this.btn_lock = false
                    }
                }
            })
        },

        buy() {
            let self = this
            if (this.btn_lock) {
                return false
            }
            this.btn_lock = 1
            this.$http
                .q_hd(
                    'PubPay',
                    'https://wx.pay.09game.com/WeChatPay/',
                    {
                        token: this.token,
                        total_fee: Number(this.pay_jiubi),
                    },
                    true
                )
                .then((res) => {
                    this.btn_lock = 0
                    if (res.code == 1) {
                        alert(res.msg)
                    } else if (res.code == 0) {
                        // console.log(res.data)
                        self.payData = res.data
                        if (typeof WeixinJSBridge == 'undefined') {
                            if (document.addEventListener) {
                                document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false)
                            } else if (document.attachEvent) {
                                document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady)
                                document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady)
                            }
                        } else {
                            self.onBridgeReady()
                        }
                    }
                })
        },

        onBridgeReady() {
            let self = this
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest',
                {
                    appId: this.payData.appId, //公众号名称，由商户传入 ok
                    timeStamp: this.payData.timeStamp, //时间戳，自1970年以来的秒数 ok
                    nonceStr: this.payData.nonceStr, //随机串
                    package: this.payData.package,
                    signType: 'MD5', //微信签名方式
                    paySign: this.payData.paySign, //微信签名
                },
                function (res) {
                    if (res.err_msg == 'get_brand_wcpay_request:ok') {
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        self.buy_goods()
                    } else {
                        if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                            alert('取消支付！')
                        } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            alert('支付失败！')
                        } else {
                            alert(res.err_msg)
                        }
                    }
                }
            )
        },
        // 打开礼包plus专属
        open_packet_plus(item, index) {
            var _this = this
            if (this.btn_lock) {
                return false
            }
            let element = `.task-list .task-item${index} .btn`
            let text = ''
            if (item.status != 'get') {
                return false
            }

            _this.btn_lock = true
            this.$http.q_hd('OpenPacket', hd_url, { token: this.token, packet_id: item.packet_id }).then((res) => {
                if (res.code == 0) {
                    text = '领取成功！'
                    _this.btn_lock = false
                    _this.query_my_packet()
                    _this.chance_amount = _this.query_my_item(_this.chance_id)
                    _this.mate_show(element, text, -30)
                } else {
                    text = res.msg ? res.msg : res.error ? res.error : '领取失败'
                    _this.btn_lock = false
                    _this.mate_show(element, text, -30)
                }
            })
        },

        // 打开礼包
        open_packet(item, index) {
            var _this = this
            if (this.btn_lock) {
                return false
            }
            let element = `.task-list .task-item${index} .btn`
            let text = ''
            if (item.status != 'get') {
                return false
            }

            _this.btn_lock = true
            this.$http.use_packet(item.packet_id, this.token, 0).then((res) => {
                if (res.code == 0) {
                    text = '领取成功'
                    _this.btn_lock = false
                    _this.query_my_packet()
                    _this.chance_amount = _this.query_my_item(_this.chance_id)
                    _this.mate_show(element, text, -30)
                } else {
                    text = res.info ? res.info : '领取失败'
                    _this.btn_lock = false
                    _this.mate_show(element, text, -30)
                }
            })
        },

        close_pop() {
            if (this.pop_show == 'toast') {
                this.prize = ''
                if (this.step_now != 6) {
                    this.current_index -= this.step_now
                    this.goBack()
                } else {
                    this.btn_lock = false
                    this.query_my_packet()
                }
            } else if (this.pop_show == 'buyPlus') {
                this.buy_index = 0
                this.pay_jiubi = 0
            }
            this.pop_show = ''
        },

        // 滚动
        roll() {
            let _this = this
            this.i++
            //计算转圈次数
            if (this.i >= this.goodsList.length) {
                this.i = 0
                this.count++
            }
            //满足转圈数和指定位置就停止
            if (this.count >= this.totalCount && this.i == this.current_index) {
                this.ball_amount = this.query_my_item(this.ball_id)
                this.getMyRank()
                setTimeout(() => {
                    _this.pop_show = 'toast'
                }, 100)
                if (this.total_step % 24 == 0) {
                    // 路过起点
                    this.getBeishu()
                }
                clearTimeout(this.timer_dice)
            } else {
                this.timer_dice = setTimeout(() => {
                    this.roll()
                }, this.speed)
            }
        },
        // 回退
        goBack() {
            let _this = this
            this.i--
            //计算转圈次数
            if (this.i <= 0) {
                this.i = 0
            }
            //满足转圈数和指定位置就停止
            if (this.i == this.current_index) {
                clearTimeout(this.timer_dice)
                setTimeout(() => {
                    _this.btn_lock = false
                }, 500)
            } else {
                this.timer_dice = setTimeout(() => {
                    this.goBack()
                }, this.minSpeed)
            }
        },

        // 开始投色子
        rollDice() {
            let _this = this
            if (this.btn_lock) {
                return false
            }
            if (this.chance_amount <= 0) {
                return false
            }
            let element = '.part-2 .btn'
            let text = ''
            this.btn_lock = true
            this.$http.q_hd('UserRolldice', hd_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg) {
                    text = res.msg ? res.msg : '操作成功'
                    this.step_now = res.msg.step
                    this.prize = res.msg.item_name
                    this.total_step = res.msg.total_step
                    this.showDiceGif()
                    this.chance_amount = this.query_my_item(this.chance_id)
                    // _this.mate_show(element, text, -30)
                } else {
                    this.btn_lock = false
                    text = res.msg ? res.msg : '操作失败，请联系管理员'
                    _this.mate_show(element, text, -30)
                }
            })
        },
        // 显示筛子动图
        showDiceGif() {
            let _this = this
            let random_num = 1100
            if (_this.oPlay) {
                _this.oPlay = false
                _this.dice_url = '0.png'
                $('.dice-img').toggleClass('add_transform')
                //随机时间后，将动态图替换为随机点数的图片
                var timer = setTimeout(() => {
                    _this.dice_url = `${_this.step_now}.png`
                    _this.oPlay = true
                }, random_num)
            }
            _this.current_index = (_this.current_index + parseInt(_this.step_now)) % 24

            this.timer_dice = setTimeout(() => {
                _this.roll()
            }, random_num + 500)
        },
        change_tab(item) {
            this.tab = item
            if (item == 4) {
                this.query_turn_log()
            } else if (item == 2) {
                this.getMyRank()
                this.getRank()
            }
        },
        requireToken() {
            var Ucookie = this.token
            if (Ucookie != null) {
                var now = new Date().getTime()
                if (now >= Ucookie.split('-')[3] * 1000) {
                    //token过期
                    this.get_auth()
                } else {
                    this.init()
                }
            } else {
                this.get_auth()
            }
        },
        get_auth() {
            window.location.replace(base_url + '/GetWxOpenid?fromPage=national_day')
        },
        async init() {
            this.token = this.$storage.getToken()
            this.user_id = this.token.split('-')[0]
            this.tab = 1
            await this.getBaseInfo()
            this.getTurnTable()
            this.query_app()
        },
        async getBaseInfo() {
            await this.$http.getUserInfo(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.user_info = Object.assign({}, this.user_info, res.temp)
                    this.$storage.setUserId(this.user_info.user_id)
                    this.$storage.setUserName(this.user_info.name)
                    this.$storage.setHeadId(this.user_info.avtar_head)
                    this.$storage.setUserLevel(this.user_info.level)
                    this.$storage.setUserFlag(this.user_info.flag)
                    this.user_id = this.user_info.user_id
                    this.user_name = this.user_info.name
                }
            })
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg
                    this.$storage.setAccountList(JSON.stringify(res.msg))
                } else {
                    this.account_list = []
                }
            })
            this.$http.q_my_money(this.token).then((res) => {
                if (res.code == 0 && res.records && res.records.length > 0) {
                    let msg = res.records[0]
                    this.jiubi = msg ? msg.money1 : 0
                }
            })
        },
        rand(min, max) {
            if (min > max) {
                var mid = min
                min = max
                max = mid
            }
            return parseInt(Math.random() * (max - min + 1) + min)
        },
        mate_show(element, text, offsetTop, offsetLeft = 5) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth + offsetLeft
            var css = {
                top: cssTop,
                left: cssLeft,
            }
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/nationalDay/index.scss';
</style>




// WEBPACK FOOTER //
// src/view/national_day.vue